import { FlexibleWorkTimeMonitoringActions } from 'src/store/actions/flexibleWorkTimeMonitoringActions';
const initialState = {
    data: null,
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_REQUEST: {
            return ({
                ...state,
                loading: true
            });
        }
        case FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_SUCCESS: {
            return ({
                ...state,
                loading: false,
                data: payload || null
            });
        }
        case FlexibleWorkTimeMonitoringActions.GET_FLEXIBLE_WORK_TIME_MONITORING_FAIL: {
            return ({
                ...state,
                loading: false
            });
        }
        default: return state;
    }
};
